var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg1Filled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "circle-1",
    clipPath: "url(#clip0_1003_1688)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16 0C7.1625 0 0 7.1625 0 16C0 24.8375 7.1625 32 16 32C24.8375 32 32 24.8375 32 16C32 7.1625 24.8375 0 16 0ZM20 24H12C11.1719 24 10.5 23.3281 10.5 22.5C10.5 21.6719 11.175 21 12 21H14.5V12.3L13.5813 12.9125C12.8938 13.3688 11.9625 13.1313 11.5 12.4438C11.0437 11.8063 11.2312 10.875 11.9187 10.4187L15.1687 8.2525C15.6307 7.94387 16.2225 7.91656 16.7087 8.17825C17.1938 8.4375 17.5 8.95 17.5 9.5V21H20C20.8281 21 21.5 21.6719 21.5 22.5C21.5 23.3281 20.8312 24 20 24Z",
    fill: "#757575"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1003_1688"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1Filled);
export default __webpack_public_path__ + "static/media/1filled.2f77e229cd7442291af530d777c3033e.svg";
export { ForwardRef as ReactComponent };